import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import Rating, { THEMES } from '../../../Rating';
import './style.scss';

const Ranking = ({ starSummary = {} }) => (
    <div className="ranking">
        <h6 className="text-display-7">
            <I18n k="reviews.breakdown.title" />
        </h6>
        <ul>
            {Object.keys(starSummary).map((value, index) => (
                <li key={index}>
                    <I18n k={`reviews.gigs._rating.${value}`} />
                    <span>
                        <Rating score={starSummary[value]} theme={THEMES.ONE_STAR} />
                    </span>
                </li>
            ))}
        </ul>
    </div>
);

Ranking.propTypes = {
    starSummary: PropTypes.object,
};

export default Ranking;
